import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Modal, Validators } from "@softline/ui-core";
import { Edelmetall } from "../../types/produktkalkulation";
import { DynamicModule } from "@softline/dynamic";

import { InputComponent } from '@softline/ui-core';
import { NumberInputComponent } from '@softline/ui-core';
@Component({
    selector: 'soft-edelmetallkurs',
    imports: [ReactiveFormsModule,
    InputComponent,
    NumberInputComponent],
    templateUrl: './edelmetallkurs.dialog.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./edelmetallkurs.dialog.css']
})
export class EdelmetallkursDialog implements OnInit,  Modal<Partial<Edelmetall>> {

  form = new FormGroup({
    begriff: new FormControl<number | null>(null, [Validators.required()]),
    betrag: new FormControl<number | null>(null, [Validators.required()]),
    verarbeitungsverlust: new FormControl<number | null>(null, [Validators.required()]) });

  set value(value: Edelmetall) {
    this.form.patchValue(value as any);
  }

  close!: (result: Partial<Edelmetall>) => void;

  constructor() { }

  ngOnInit(): void {
  }

  registerCloseHandler(handler: (result: Partial<Edelmetall>) => void): void {
    this.close = handler;
  }

  onSubmit(): void {
    if(this.form.invalid)
      return;
    this.close(this.form.value as any);
  }

}
